/* eslint-disable indent */
import {
  format,
  formatDistanceToNow,
  getTime,
  isToday as dateFnsIsToday,
  isYesterday as dateFnsIsYesterday,
} from 'date-fns';

// ----------------------------------------------------------------------

type DateType = Date | number | string;

export function fDate(date: DateType, newFormat?: string) {
  const fm = newFormat || 'yyyy/MM/dd';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date: DateType, newFormat?: string) {
  const fm = newFormat || 'yyyy/MM/dd HH:mm';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date: DateType) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date: DateType) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

export function shortDateLabel(startDate: Date | undefined, endDate: Date | undefined) {
  if (!startDate) return null;

  endDate = endDate ?? startDate;

  return `${fDate(startDate, 'yyyy/MM/dd')} - ${fDate(endDate, 'yyyy/MM/dd')}`;
}

function getShortTime(date: Date, type: 'today' | 'yesterday'): string {
  const timeString = format(date, 'HH:mm');

  return `${type === 'today' ? '' : 'Yesterday:'} ${timeString}`;
}

function isToday(date: Date): boolean {
  return dateFnsIsToday(date);
}

function isYesterday(date: Date): boolean {
  return dateFnsIsYesterday(date);
}

export function convertDate(value: Date | string | { seconds: number; nanoseconds: number }): string {
  if (!value) return getShortTime(new Date(), 'today');

  // Handle Firestore Timestamp object
  let date: Date;

  if (typeof value === 'object' && 'seconds' in value && 'nanoseconds' in value) {
    // Convert Firestore timestamp to milliseconds and create a Date object
    date = new Date(value.seconds * 1000 + value.nanoseconds / 1000000);
  } else {
    date = new Date(value);
  }

  if (isToday(date)) return getShortTime(date, 'today');

  if (isYesterday(date)) return getShortTime(date, 'yesterday');

  // Format: "2 Jan 2024, 14:30"
  return format(date, 'd MMM yyyy, HH:mm');
}
